import { Card } from "@mui/material"

export default function Privacy(){
    return <Card sx={{width: "90vw", mt: 2, mx: 'auto', px: 10, pt: 1, pb: 10}}>
        <h2>Privacy Policy</h2>
        <h4>Effective Date: 2023-05-01</h4>
        <p>
            Thank you for choosing NexSpec, LLC. 
            At NexSpec, we are committed to protecting your privacy and ensuring the security of your information. 
            This Privacy Policy outlines how we collect, use, and protect non-personally identifiable information when 
            you use our software-as-a-service (SaaS) platform or other services.
        </p>

        <h4>Information We Collect</h4>
        <p>
            We want to reassure you that we do not collect any personally identifiable information (PII) when you use our services. 
            We focus on providing our services without intruding on your privacy. We only collect non-personally identifiable 
            information that is necessary for the operation and improvement of our services. This information may include:
        </p>

        <h5>Device information:</h5> 
        <p>We may collect technical information about the device you use to access our SaaS platform, such as the device type, operating system, and browser type.</p>
        <h5>Log data:</h5> 
        <p>
            Our servers automatically record certain information, such as your IP address, the pages you visit, and the actions you take on our platform. 
            This data is used for system administration purposes, to analyze trends, and to gather demographic information.
        </p>
        <h5>Cookies and similar technologies:</h5>
        <p>
            We may use cookies and similar technologies to enhance your experience on our platform. These technologies help us recognize your preferences, customize 
            your user interface, and collect non-personally identifiable information. You can manage or disable cookies through your browser settings.
        </p>

        <h4>Use of Information</h4>
        <p>The non-personally identifiable information we collect is used solely for the purpose of operating, maintaining, and improving our SaaS platform. We may use this information to:</p>
        <ul>
            <li>Monitor and analyze user trends, preferences, and usage patterns to enhance our services.</li>
            <li>Diagnose and resolve technical issues.</li>
            <li>Develop new features and functionality.</li>
            <li>Compile aggregated statistics for internal reporting purposes.</li>
            <li>We do not sell, rent, or share any non-personally identifiable information collected from our users with third parties, except as described in this Privacy Policy.</li>
        </ul>

        <h4>Third-Party Services</h4>
        <p>
            We may engage third-party service providers to assist us in delivering our services effectively. 
            These providers may have access to non-personally identifiable information solely for the purpose 
            of performing their services on our behalf. We ensure that any third-party service providers we 
            work with are obligated to protect the confidentiality and security of your information.
        </p>

        <h4>Data Security</h4>
        <p>
            We take the security of your information seriously and have implemented industry-standard measures to protect it from unauthorized access, 
            alteration, disclosure, or destruction. However, please note that no method of transmission over the internet or electronic storage 
            is completely secure, and we cannot guarantee absolute security.
        </p>

        <h4>Children's Privacy</h4>
        <p>Our SaaS platform is not intended for use by individuals under the age of 18. We do not knowingly collect any information from individuals under 18 years of age. If you believe that we have unintentionally collected information from a child, please contact us immediately, and we will promptly remove the information from our records.</p>

        <h4>Changes to this Privacy Policy</h4>
        <p>We may update this Privacy Policy from time to time to reflect changes in our practices or legal obligations. We encourage you to review this policy periodically to stay informed about how we collect, use, and protect your information.</p>

        <h4>Contact Us</h4>
        <p>If you have any questions or concerns regarding this Privacy Policy or our privacy practices, please contact us at info@nexspec.com.</p>
    </Card>
}